var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main__content content"},[(_vm.isLoadingTable)?_c('SpinnerLoading',{staticClass:"loader_center",attrs:{"color":"blue"}}):_vm._e(),_c('PacsTable',{attrs:{"column-captions":_vm.columnCaptions,"column-names":_vm.columnNames,"data-rows":_vm.dataRows,"page-count":1,"view-only-mode":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }